import * as React from "react";
import type { SVGProps } from "react";
const SvgManualTransmissionInCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M7 8a1 1 0 0 1 2 0v3h2V8a1 1 0 1 1 2 0v3h2V8a1 1 0 1 1 2 0v4a1 1 0 0 1-1 1h-3v3a1 1 0 1 1-2 0v-3H9v3a1 1 0 1 1-2 0z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 22C6.49 22 2 17.51 2 12S6.49 2 12 2s10 4.49 10 10-4.49 10-10 10m0-18c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgManualTransmissionInCircle;
